import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { observer, PropTypes as MobxPropTypes } from 'mobx-react'
import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'

import { Button, Col, Row } from 'antd'
import { BREAK_POINTS_NUMBERS } from 'flynk.app.web.core.components/constants'
import PropTypes from 'prop-types'

import { GIG_TYPES, NO_PERFORMANCE, NO_RECEPTION } from '@/constants'

import { postAMessageFromIframeToParent } from '../../../helpers/common'
import VideoPlayer from './VideoPlayer'
import { VideosSwiperList } from './VideosSwiperList'

const CONVERSION_VIDEO_SLIDER_STEP = 1

@observer
export class ReceptionMusicModalItem extends Component {
  static propTypes = {
    booking: MobxPropTypes.objectOrObservableObject,
    isActive: PropTypes.bool.isRequired,
    performance: MobxPropTypes.objectOrObservableObject,
    selectReceptionPerformance: PropTypes.func.isRequired,
    swiperInstance: MobxPropTypes.objectOrObservableObject,
    toggleReceptionMusicModalVisible: PropTypes.func,
    isPrivateEventBooking: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    booking: {},
    performance: {},
    swiperInstance: {},
    toggleReceptionMusicModalVisible: () => {},
  }

  constructor(props) {
    super(props)
    this.receptionModalItemDetail = React.createRef()
    this.swiperRef = React.createRef()
    this.setShowMoreExpanded = this.setShowMoreExpanded.bind(this)
    const [video] = props?.performance?.videos ?? []
    this.state = {
      isExpanded: false,
      mainVideoId: props.performance.id === NO_RECEPTION ? '' : video?.videoUrl,
      mainThumb:
        props.performance.id === NO_RECEPTION ? '' : video?.thumbnailUrl,
      isMobile: window.innerWidth < BREAK_POINTS_NUMBERS.lg,
    }

    const { id } = this.props.performance
    this.swiperSettings = {
      direction: 'horizontal',
      slidesPerView: 3,
      spaceBetween: 10,
      navigation: {
        clickable: true,
        nextEl: `.gig-${id}.swiper-video-arrow.swiper-video-arrow-next`,
        prevEl: `.gig-${id}.swiper-video-arrow.swiper-video-arrow-prev`,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        [BREAK_POINTS_NUMBERS.xl]: {
          slidesPerView: 3,
        },
        [BREAK_POINTS_NUMBERS.xxl]: {
          slidesPerView: 4,
        },
      },
      onSwiper: swiper => {
        this.swiperRef.current = swiper
      },
      observer: true,
      observeParents: true,
    }
  }

  componentDidUpdate({ performance }) {
    const { id, videos } = this.props.performance
    const { id: oldId, videos: oldVideos } = performance

    const [video] = videos ?? []
    const [oldVideo] = oldVideos ?? []

    if (id !== oldId || video?.thumbnailUrl !== oldVideo?.thumbnailUrl) {
      this.handleUpdateState()

      // update navigate arrow after change slider
      this.swiperRef?.current?.navigation?.update()
      window.dispatchEvent(new Event('resize'))
    }
  }

  onClickControlButtonForVideo(stepNumber) {
    const { videos } = this.props.performance
    const { mainVideoId } = this.state

    const currentVideoIndex = videos.findIndex(
      video => video.videoUrl === mainVideoId
    )
    const conversionVideoIndex = currentVideoIndex + stepNumber

    const nextVideo = videos[conversionVideoIndex]

    if (nextVideo) {
      this.replaceMainVideo(nextVideo.videoUrl, nextVideo.thumbnailUrl)
    }

    // change thumbnail swiper depend on current video URL
    this.swiperRef?.current?.slideTo(conversionVideoIndex)
  }

  handleUpdateState = () => {
    const { id, videos } = this.props.performance
    const [video] = videos ?? []

    this.setState({
      mainVideoId: !videos || id === NO_RECEPTION ? '' : video.videoUrl,
      mainThumb: !videos || id === NO_RECEPTION ? '' : video.thumbnailUrl,
    })
  }

  selectPerformance = () => {
    const {
      isActive,
      performance,
      selectReceptionPerformance,
      toggleReceptionMusicModalVisible,
    } = this.props

    if (isActive) {
      selectReceptionPerformance(performance.id)
      toggleReceptionMusicModalVisible()
      postAMessageFromIframeToParent('IsSelectedItemOnReceptionPage', true)
    }
  }

  setShowMoreExpanded = (forceClose = false) => {
    if (
      this.receptionModalItemDetail &&
      this.receptionModalItemDetail.current
    ) {
      this.receptionModalItemDetail.current.scrollTo(0, 0)
    }

    this.setState(
      ({ isExpanded }) => ({
        isExpanded: forceClose ? false : !isExpanded,
      }),
      () => {
        window.dispatchEvent(new Event('resize'))
      }
    )
  }

  toggleExpandClick = () => {
    this.setShowMoreExpanded(false)
  }

  renderNoReception = () => {
    const {
      performance: { selected },
      isPrivateEventBooking,
    } = this.props

    const noPerformanceLabel = isPrivateEventBooking
      ? NO_PERFORMANCE.Reception.privateLabel
      : NO_PERFORMANCE.Reception.label

    const noPerformanceDescLabel = (
      isPrivateEventBooking ? GIG_TYPES.DanceFloor : GIG_TYPES.Reception
    ).toLowerCase()

    return (
      <div className="reception-modal-item">
        <div className="band-modal-content-no-cat no-cat">
          <div className="band-modal-content-no-cat__centering">
            <p className="band-modal-content-no-cat__title no-cat__title">
              {noPerformanceLabel}
            </p>
            <p className="band-modal-content-no-cat__des">
              Select this option if you don&apos;t need us for your{' '}
              {noPerformanceDescLabel} music.
            </p>
            {selected ? (
              <Button
                type="primary"
                className="qb-button qb-button-change selected"
                onClick={this.selectPerformance}
              >
                Selected
              </Button>
            ) : (
              <Button
                type="primary"
                className="qb-button qb-button-change"
                onClick={this.selectPerformance}
              >
                Select
              </Button>
            )}
          </div>
          <div className="band-modal-content-no-cat__centering mobile">
            <div className="band-modal-content-no-cat__icon no-cat__icon">
              <img src="/images/no-cat-icon.svg" alt="no-cat-icon" />
            </div>
            <p className="band-modal-content-no-cat__title no-cat__title">
              {noPerformanceLabel}
            </p>
            {selected ? (
              <Button
                type="primary"
                className="qb-button qb-button-change selected"
                onClick={this.selectPerformance}
              >
                Selected
              </Button>
            ) : (
              <Button
                type="primary"
                className="qb-button qb-button-change"
                onClick={this.selectPerformance}
              >
                Select
              </Button>
            )}
            <p className="band-modal-content-no-cat__des">
              Select this option if you don&apos;t need us for your{' '}
              {noPerformanceDescLabel} music.
            </p>
          </div>
        </div>
      </div>
    )
  }

  replaceMainVideo = (performanceVideoId, performanceThumbUrl) => {
    this.setState({
      mainVideoId: performanceVideoId,
      mainThumb: performanceThumbUrl,
    })
  }

  render() {
    const { isExpanded, mainVideoId, mainThumb, isMobile } = this.state

    const { booking, performance, swiperInstance } = this.props

    const { name, price, id, selected, videos, moreInfo } = performance

    if (id === NO_RECEPTION) {
      return this.renderNoReception()
    }

    return (
      <div
        className={`reception-modal-item ${isExpanded || isMobile ? 'expanded' : ''} reception-${id}`}
      >
        <div className="reception-modal-item-video-wrapper">
          <div className="reception-modal-item-video-placeholder">
            <div className="control-video-slider">
              <button
                type="button"
                className="control-video-slider-arrow control-video-slider-arrow-prev"
                onClick={() =>
                  this.onClickControlButtonForVideo(
                    -CONVERSION_VIDEO_SLIDER_STEP
                  )
                }
              >
                <FontAwesomeIcon icon={['far', 'chevron-left']} />
              </button>
              <button
                type="button"
                className="control-video-slider-arrow control-video-slider-arrow-next"
                onClick={() =>
                  this.onClickControlButtonForVideo(
                    CONVERSION_VIDEO_SLIDER_STEP
                  )
                }
              >
                <FontAwesomeIcon icon={['far', 'chevron-right']} />
              </button>
            </div>
            <span>Placeholder</span>
          </div>
          <div className="reception-modal-item-video">
            {mainVideoId ? (
              <VideoPlayer
                src={mainVideoId}
                poster={mainThumb}
                key={mainThumb}
              />
            ) : (
              <img
                className="reception-modal-item-main-img"
                alt=""
                src={mainThumb}
              />
            )}
          </div>
          <VideosSwiperList
            key="reception-modal"
            id={`gig-${id}`}
            mainVideoId={mainVideoId}
            replaceMainVideo={this.replaceMainVideo}
            videos={videos}
            swiperSettings={this.swiperSettings}
          />
        </div>
        <div
          className="reception-modal-item-detail"
          ref={this.receptionModalItemDetail}
        >
          <div className="reception-modal-item-detail-scroll">
            <div className="reception-modal-item-detail-header">
              <Row gutter={[0, 10]}>
                <Col xs={18} xl={24}>
                  <h3 className="reception-modal-item-title">{name}</h3>
                </Col>
                <Col xs={6} xl={24}>
                  <div
                    className={`reception-modal-item-price ${booking?.id ? '' : 'blur-item'}`}
                  >
                    PRICE
                    <span className="reception-modal-item-price-number">
                      $ {price}
                    </span>
                  </div>
                </Col>
              </Row>
              <div className="end-same-line">
                {selected ? (
                  <Button
                    type="primary"
                    className="qb-button qb-button-change selected"
                    onClick={this.selectPerformance}
                  >
                    Selected
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    className="qb-button qb-button-change"
                    onClick={this.selectPerformance}
                  >
                    Select
                  </Button>
                )}
              </div>
            </div>
            <div
              className={`reception-modal-item-des qb-scroll-has-track-piece ${isExpanded ? 'opened' : ''}`}
              onMouseEnter={() => {
                swiperInstance?.mousewheel?.disable()
              }}
              onMouseLeave={() => {
                swiperInstance?.mousewheel?.enable()
              }}
            >
              <ReactMarkdown>{moreInfo}</ReactMarkdown>
            </div>
          </div>
          {!isMobile && (
            <>
              <div
                className="reception-modal-item-show-more-box show-more"
                onClick={this.toggleExpandClick}
                onKeyUp={this.toggleExpandClick}
                role="button"
                tabIndex="0"
              >
                <div className="reception-modal-item-show-more-box-button">
                  Show more <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                </div>
              </div>
              <div
                className="reception-modal-item-show-more-box show-less"
                onClick={this.toggleExpandClick}
                onKeyUp={this.toggleExpandClick}
                role="button"
                tabIndex="0"
              >
                <div className="reception-modal-item-show-more-box-button">
                  Show less <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    )
  }
}
